import { render, staticRenderFns } from "./NovaCotacao.vue?vue&type=template&id=3df59e4b&scoped=true&"
import script from "./NovaCotacao.vue?vue&type=script&lang=js&"
export * from "./NovaCotacao.vue?vue&type=script&lang=js&"
import style0 from "./NovaCotacao.vue?vue&type=style&index=0&id=3df59e4b&prod&lang=scss&scoped=true&"
import style1 from "./NovaCotacao.vue?vue&type=style&index=1&id=3df59e4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df59e4b",
  null
  
)

export default component.exports